import { auth, provider } from "../config/firebase";
import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

export const Account = () => {
  const navigate = useNavigate();

  const [user, loading, error] = useAuthState(auth);

  const singInWithGoole = async () => {
    const result = await signInWithPopup(auth, provider);
    console.log(result);
    navigate("/");
  };
  return (
    <div>
      <h1>Account</h1>
      {!user && (
        <div>
          <p>Sign in with google to continue</p>
          <button className='btn btn-primary' onClick={singInWithGoole}>
            Sign in with Google
          </button>
        </div>
      )}
      {user && (
        <h5>
          Logged in as <span className='fst-italic fw-bolder'>{user?.email}</span>
        </h5>
      )}
    </div>
  );
};
